import { io } from 'socket.io-client'
import { LOCAL_STORAGE } from 'src/helpers/constants'

// "undefined" means the URL will be computed from the `window.location` object
// URL chỉ được chứa origin (scheme://host:port). Nếu để kèm path như "/api",
// socket.io-client sẽ hiểu đó là namespace chứ không phải path.
const URL = process.env.REACT_APP_SOCKET_URL || ''
// Path của endpoint socket.io. Khi backend nằm sau reverse proxy có tiền tố
// (ví dụ nginx proxy /api/ -> backend), khai báo "/api/socket.io".
const PATH = process.env.REACT_APP_SOCKET_PATH || '/socket.io'
const dataAuth = localStorage.getItem(LOCAL_STORAGE.DATA_AUTH)
const tokensString = dataAuth ? JSON.parse(dataAuth) : ''
const token = tokensString?.tokens?.access?.token

export const socket = io(URL, {
   path: PATH,
   reconnectionDelayMax: 10000,
   autoConnect: false,
   query: {
      token: token
   }
})
